// PRODUCTION
export const SERVER_URL = "https://bayannopay.top";
// export const SERVER_URL = "https://bayannopay.net";
// export const SERVER_URL = "http://130.185.119.221:4000"
// export const SERVER_URL = "http://45.77.101.195:5000"

// DEVELOPMENT
// export const SERVER_URL = "http://localhost:5002";
